// extracted by mini-css-extract-plugin
export default {"absolute":"absolute__EcfPw","animation":"animation__kWyn6","fade":"fade__43uSu"};